import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import API from "../Service/Baseservice";
import UploadIcon from "../../Assets/img/upload.png";
import CharIcon from "../../Assets/img/word.png";
import defaultImg from "../../Assets/img/default-image.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import TestimonialReviewPreview from "./TestimonialReviewPreview";
const TestimonialReviewEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();

    const reviewData = location.state?.testimonialreview;

    useEffect(() => {
        if (!reviewData) {
            navigate(`/testimonialedit/${id}`);
        }
    }, [reviewData]);

    const [loading, setLoading] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(reviewData?.imageupload || defaultImg);
    const [uploadedUrl, setUploadedUrl] = useState(null);
    const [isUpdating, setIsUpdating] = useState(false);
    const [showPreviewTestimonialReview, setShowPreviewTestimonialReview] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [formData, setFormData] = useState({
        review_id: reviewData?.review_id,
        language_id: reviewData?.language_id,
        testimonial_id: reviewData?.testimonial_id,
        name: reviewData?.name || "",
        professional: reviewData?.professional || "",
        rating: reviewData?.rating || 5,
        description: reviewData?.description || "",
        imageupload: reviewData?.imageupload || "",
        status: reviewData?.status || "active",
        active: reviewData?.active || 1,
    });


    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "",
    });

    const getPlainTextLength = (html = "") => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent?.length || 0;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleUpdate = () => {
        if (!formData.name || !formData.professional || !formData.description) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all required fields",
                type: "info",
            });
            return;
        }

        setIsUpdating(true);
    };

    useEffect(() => {
        if (isUpdating) {
            if (imageFile) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64Image = reader.result;

                    const body = {
                        name: imageFile.name,
                        image: [
                            {
                                name: imageFile.name,
                                type: imageFile.type,
                                size: `${imageFile.size} bytes`,
                                base64: base64Image,
                            },
                        ],
                    };

                    setLoading(true);

                    API.post("imageUpload/add", body)
                        .then((res) => {
                            setUploadedUrl(res.data?.url);
                        })
                        .catch(() => {
                            setPopup({
                                show: true,
                                title: "Error",
                                message: "Image upload failed",
                                type: "failed",
                            });
                            setIsUpdating(false);
                        });
                };

                reader.readAsDataURL(imageFile);
            } else {
                setUploadedUrl(formData.imageupload);
            }
        }
    }, [isUpdating]);

    useEffect(() => {
        if (uploadedUrl && isUpdating) {
            const payload = {
                ...formData,
                imageupload: uploadedUrl,
            };

            API.post("videoreview_edit/update", payload)
                .then(() => {
                    setPopup({
                        show: true,
                        title: "Success",
                        message: "Review updated successfully!",
                        type: "success",
                    });

                    setTimeout(() => {
                        navigate(`/testimonialedit/${id}`);
                    }, 2000);
                })
                .catch(() => {
                    setPopup({
                        show: true,
                        title: "Error",
                        message: "Failed to update review",
                        type: "failed",
                    });
                })
                .finally(() => {
                    setLoading(false);
                    setIsUpdating(false);
                });
        }
    }, [uploadedUrl]);

    const handlePreview = () => {
        if (!formData.name.trim()) {
            setPopup({ show: true, title: "Required", message: "Name is required!", type: "info" });
            return;
        }
        if (!formData.professional.trim()) {
            setPopup({ show: true, title: "Required", message: "Profession is required!", type: "info" });
            return;
        }
        if (!formData.description.trim()) {
            setPopup({ show: true, title: "Required", message: "Description is required!", type: "info" });
            return;
        }

        const testimonialId = formData.testimonial_id;

        Promise.all([
            API.post("testimoniallistview/condition", { language_id: 1, home_id: 2, testimonial_id: testimonialId }),
            API.post("testimoniallistview/condition", { language_id: 2, home_id: 4, testimonial_id: testimonialId })
        ])
            .then(([res1, res2]) => {
                const reviews1 = res1.data?.data?.video_reviews || [];
                const reviews2 = res2.data?.data?.video_reviews || [];

                const combinedReviews = [...reviews1, ...reviews2];

                const allReviews = combinedReviews.map((r) =>
                    r.review_id.toString() === formData.review_id.toString()
                        ? {
                            ...r,
                            name: formData.name,
                            professional: formData.professional,
                            rating: formData.rating,
                            description: formData.description,
                            imageupload: imagePreview || defaultImg,
                        }
                        : r
                );

                setPreviewData(allReviews);
                setShowPreviewTestimonialReview(true);
            })
            .catch(err => console.error("Failed to fetch reviews", err));
    };


    return (
        <div className="newss-containeradd">
            <div className="service-header-bar">
                <h2>Edit Review Testimonial</h2>

                <div className="button-group">
                    <button onClick={handlePreview} className="saves-btn">
                        Preview
                    </button>
                    <button className="saves-btn" onClick={handleUpdate}>
                        {loading ? "Save" : "Save"}
                    </button>
                    <button
                        onClick={() => navigate(`/testimonialedit/${id}`)}
                        className="cancel-btn "
                    >
                        Back
                    </button>
                </div>
            </div>

            <div className="service-container">

                {/* LEFT SIDE */}
                <div className="left-form">
                    <div className="upload-section">
                        <label>Upload Image <span className="required">*</span></label>
                        <div className="service-upload-box">
                            {imagePreview ? (
                                <img src={imagePreview} className="preview-img" alt="Preview" />
                            ) : (
                                <>
                                    <img src={UploadIcon} className="upload-icon" alt="Upload" />
                                    <p>Click to upload</p>
                                </>
                            )}
                            <input type="file" accept="image/*" onChange={handleImageUpload} />
                        </div>
                    </div>
                </div>

                {/* RIGHT SIDE */}
                <div className="serviceadd-right-section">
                    <div className="form-group">
                        <label>Name <span className="required">*</span></label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <label>Profession <span className="required">*</span></label>
                        <input
                            type="text"
                            name="professional"
                            value={formData.professional}
                            onChange={handleChange}
                        />
                    </div>

                    {/* RATING */}
                    <div className="form-group">
                        <label>Rating</label>
                        <select
                            name="rating"
                            value={formData.rating}
                            onChange={handleChange}
                        >
                            {[5, 4, 3, 2, 1].map((n) => (
                                <option key={n} value={n}>{n} Stars</option>
                            ))}
                        </select>
                    </div>

                    {/* DESCRIPTION */}
                    <div className="news-form-group review-editor-small">
                        <label >
                            <span>Description <span className="required">*</span></span>
                        </label>

                        <CKEditor
                            editor={ClassicEditor}
                            data={formData.description}
                            onChange={(event, editor) =>
                                setFormData({ ...formData, description: editor.getData() })
                            }
                            config={{
                                toolbar: [
                                    "undo", "redo", "|",
                                    "heading", "|",
                                    "bold", "italic", "underline", "|",
                                    "bulletedList", "numberedList",
                                ],
                            }}
                        />
                    </div>
                </div>
            </div>

            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <button
                            className="btn ok-btn"
                            onClick={() => setPopup({ ...popup, show: false })}
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
            {showPreviewTestimonialReview && (
                <TestimonialReviewPreview
                    previewService={previewData}
                    setShowPreviewTestimonialReview={setShowPreviewTestimonialReview}
                />
            )}
        </div>
    );
};

export default TestimonialReviewEdit;
